module.exports = __webpack_public_path__ + "static/media/buyerNew2.80164197.png";